import React, { useState, useEffect } from 'react';
import logo1 from '../src/images/logo1.png';
import headerImage from '../src/images/header.png';
import pakImanImage from '../src/images/Pak Iman.jpeg';
import buYantiImage from '../src/images/Bu Yanti.jpeg';
import InstagramWidget from './InstagramWidget';
import {
  MassageIcon,
  UserIcon,
  SparkleIcon,
  HeartIcon,
  InstagramIcon,
} from './components/icons/SvgIcons';
import {
  MassageServiceImage,
  ReflectionServiceImage,
  CuppingServiceImage,
  FaceServiceImage,
  KretekServiceImage,
  StoneServiceImage,
  ScrappingServiceImage,
  ScrubServiceImage,
  KidsMassageServiceImage
} from './components/icons/ServiceImages';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  
  // Contact form state
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    service: '',
    message: '',
    serviceDate: '',
    gender: '',
    address: '',
    reservationTime: '',
    numberOfPeople: 1
  });

  // Testimonial form state
  const [testimonialData, setTestimonialData] = useState({
    name: '',
    rating: 0,
    selectedOptions: [] as string[],
    customText: ''
  });

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 100; // Account for fixed navbar
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
    setActiveSection(sectionId);
    closeMenu();
  };

  // Handle form input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle form submission
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Create WhatsApp message
    const message = `Assalamu'alaikum minspa! 🌸

📝 DETAIL RESERVASI:
👤 Nama: ${formData.name}
📞 No. HP: ${formData.phone || 'Tidak diisi'}
🗓️ Tanggal Layanan: ${formData.serviceDate || 'Belum dipilih'}
⏰ Waktu Reservasi: ${formData.reservationTime || 'Belum dipilih'}
👫 Jenis Kelamin: ${formData.gender || 'Tidak diisi'}
👥 Jumlah Orang: ${formData.numberOfPeople} orang
💆‍♀️ Layanan: ${formData.service || 'Belum dipilih'}
📍 Alamat: ${formData.address || 'Belum diisi'}

💬 Pesan:
${formData.message}

Terima kasih! 🙏`;
    
    const phoneNumber = "6282289998442";
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, "_blank");
  };

  // Handle testimonial input changes
  const handleTestimonialInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setTestimonialData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle testimonial option selection
  const handleTestimonialOptionChange = (option: string) => {
    setTestimonialData(prev => {
      const isSelected = prev.selectedOptions.includes(option);
      const newOptions = isSelected 
        ? prev.selectedOptions.filter(opt => opt !== option)
        : [...prev.selectedOptions, option];
      
      return {
        ...prev,
        selectedOptions: newOptions
      };
    });
  };

  // Handle star rating
  const handleStarRating = (rating: number) => {
    setTestimonialData(prev => ({
      ...prev,
      rating
    }));
  };

  // Handle testimonial submission
  const handleTestimonialSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Combine selected options with custom text
    const selectedText = testimonialData.selectedOptions.length > 0 
      ? testimonialData.selectedOptions.join(', ')
      : '';
    
    const finalText = selectedText && testimonialData.customText 
      ? `${selectedText}. ${testimonialData.customText}`
      : selectedText || testimonialData.customText;
    
    // Create WhatsApp message
    const message = `Assalamu'alaikum minspa! 🌸

TESTIMONI BARU:
Nama: ${testimonialData.name}
Rating: ${testimonialData.rating}/5 bintang

Testimoni:
"${finalText}"

Terima kasih atas kepercayaannya! 🙏`;
    
    const phoneNumber = "6282289998442";
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, "_blank");
    
    // Reset form
    setTestimonialData({
      name: '',
      rating: 0,
      selectedOptions: [],
      customText: ''
    });
    
    alert('Terima kasih atas testimoni Anda! 🙏');
  };

  // Track active section based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'services', 'about', 'testimonials', 'therapist', 'faq', 'contact'];
      const scrollPos = window.scrollY + 200;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetBottom = offsetTop + element.offsetHeight;

          if (scrollPos >= offsetTop && scrollPos < offsetBottom) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white/20 backdrop-blur-xl border-b border-white/30 z-50 py-4 shadow-2xl">
        <div className="max-w-6xl mx-auto px-5 flex items-center relative">
          <img src={ logo1 } alt='Blisspa - Pijat Muslim Muslimah Bandung Logo' style={{ width: 100 }}/>
          
          {/* Hamburger Menu Button */}
          <button 
            className="md:hidden absolute right-0 flex flex-col gap-1.5 cursor-pointer p-2 rounded-lg bg-white/20 backdrop-blur-md border border-white/30 hover:bg-white/30 transition-all duration-300"
            onClick={toggleMenu}
          >
            <span className={`w-6 h-0.5 bg-gray-800 transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
            <span className={`w-6 h-0.5 bg-gray-800 transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
            <span className={`w-6 h-0.5 bg-gray-800 transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
          </button>
          
          {/* Desktop Menu - Centered */}
          <ul className="hidden md:flex space-x-6 text-center absolute left-1/2 transform -translate-x-1/2">
            <li><button onClick={() => scrollToSection('home')} className={`text-gray-800 font-semibold px-4 py-2 rounded-lg backdrop-blur-md border transition-all duration-300 shadow-lg ${activeSection === 'home' ? 'bg-white/60 border-[#70A681] text-[#70A681]' : 'bg-white/20 border-white/30 hover:bg-white/40 hover:text-[#70A681]'}`}>Home</button></li>
            <li><button onClick={() => scrollToSection('services')} className={`text-gray-800 font-semibold px-4 py-2 rounded-lg backdrop-blur-md border transition-all duration-300 shadow-lg ${activeSection === 'services' ? 'bg-white/60 border-[#70A681] text-[#70A681]' : 'bg-white/20 border-white/30 hover:bg-white/40 hover:text-[#70A681]'}`}>Layanan</button></li>
            <li><button onClick={() => scrollToSection('about')} className={`text-gray-800 font-semibold px-4 py-2 rounded-lg backdrop-blur-md border transition-all duration-300 shadow-lg ${activeSection === 'about' ? 'bg-white/60 border-[#70A681] text-[#70A681]' : 'bg-white/20 border-white/30 hover:bg-white/40 hover:text-[#70A681]'}`}>Tentang</button></li>
            <li><button onClick={() => scrollToSection('testimonials')} className={`text-gray-800 font-semibold px-4 py-2 rounded-lg backdrop-blur-md border transition-all duration-300 shadow-lg ${activeSection === 'testimonials' ? 'bg-white/60 border-[#70A681] text-[#70A681]' : 'bg-white/20 border-white/30 hover:bg-white/40 hover:text-[#70A681]'}`}>Testimoni</button></li>
            <li><button onClick={() => scrollToSection('therapist')} className={`text-gray-800 font-semibold px-4 py-2 rounded-lg backdrop-blur-md border transition-all duration-300 shadow-lg ${activeSection === 'therapist' ? 'bg-white/60 border-[#70A681] text-[#70A681]' : 'bg-white/20 border-white/30 hover:bg-white/40 hover:text-[#70A681]'}`}>Terapis</button></li>
            <li><button onClick={() => scrollToSection('faq')} className={`text-gray-800 font-semibold px-4 py-2 rounded-lg backdrop-blur-md border transition-all duration-300 shadow-lg ${activeSection === 'faq' ? 'bg-white/60 border-[#70A681] text-[#70A681]' : 'bg-white/20 border-white/30 hover:bg-white/40 hover:text-[#70A681]'}`}>FAQ</button></li>
            <li><button onClick={() => scrollToSection('contact')} className={`text-gray-800 font-semibold px-4 py-2 rounded-lg backdrop-blur-md border transition-all duration-300 shadow-lg ${activeSection === 'contact' ? 'bg-white/60 border-[#70A681] text-[#70A681]' : 'bg-white/20 border-white/30 hover:bg-white/40 hover:text-[#70A681]'}`}>Kontak</button></li>
          </ul>
          
          {/* Mobile Menu */}
          <ul className={`md:hidden absolute top-16 right-5 bg-white/30 backdrop-blur-xl border border-white/40 rounded-2xl shadow-2xl p-6 space-y-3 transition-all duration-300 ${isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
            <li><button onClick={() => scrollToSection('home')} className={`block py-3 px-5 text-gray-800 font-semibold backdrop-blur-md border rounded-xl transition-all duration-300 shadow-lg w-full text-left ${activeSection === 'home' ? 'bg-white/60 border-[#70A681] text-[#70A681]' : 'bg-white/30 border-white/40 hover:bg-white/50 hover:text-[#70A681]'}`}>Home</button></li>
            <li><button onClick={() => scrollToSection('services')} className={`block py-3 px-5 text-gray-800 font-semibold backdrop-blur-md border rounded-xl transition-all duration-300 shadow-lg w-full text-left ${activeSection === 'services' ? 'bg-white/60 border-[#70A681] text-[#70A681]' : 'bg-white/30 border-white/40 hover:bg-white/50 hover:text-[#70A681]'}`}>Layanan</button></li>
            <li><button onClick={() => scrollToSection('about')} className={`block py-3 px-5 text-gray-800 font-semibold backdrop-blur-md border rounded-xl transition-all duration-300 shadow-lg w-full text-left ${activeSection === 'about' ? 'bg-white/60 border-[#70A681] text-[#70A681]' : 'bg-white/30 border-white/40 hover:bg-white/50 hover:text-[#70A681]'}`}>Tentang Kami</button></li>
            <li><button onClick={() => scrollToSection('testimonials')} className={`block py-3 px-5 text-gray-800 font-semibold backdrop-blur-md border rounded-xl transition-all duration-300 shadow-lg w-full text-left ${activeSection === 'testimonials' ? 'bg-white/60 border-[#70A681] text-[#70A681]' : 'bg-white/30 border-white/40 hover:bg-white/50 hover:text-[#70A681]'}`}>Testimoni</button></li>
            <li><button onClick={() => scrollToSection('therapist')} className={`block py-3 px-5 text-gray-800 font-semibold backdrop-blur-md border rounded-xl transition-all duration-300 shadow-lg w-full text-left ${activeSection === 'therapist' ? 'bg-white/60 border-[#70A681] text-[#70A681]' : 'bg-white/30 border-white/40 hover:bg-white/50 hover:text-[#70A681]'}`}>Terapis</button></li>
            <li><button onClick={() => scrollToSection('faq')} className={`block py-3 px-5 text-gray-800 font-semibold backdrop-blur-md border rounded-xl transition-all duration-300 shadow-lg w-full text-left ${activeSection === 'faq' ? 'bg-white/60 border-[#70A681] text-[#70A681]' : 'bg-white/30 border-white/40 hover:bg-white/50 hover:text-[#70A681]'}`}>FAQ</button></li>
            <li><button onClick={() => scrollToSection('contact')} className={`block py-3 px-5 text-gray-800 font-semibold backdrop-blur-md border rounded-xl transition-all duration-300 shadow-lg w-full text-left ${activeSection === 'contact' ? 'bg-white/60 border-[#70A681] text-[#70A681]' : 'bg-white/30 border-white/40 hover:bg-white/50 hover:text-[#70A681]'}`}>Kontak</button></li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section 
        id="home" 
        className="min-h-screen flex items-center justify-center text-center text-white relative overflow-hidden"
        style={{
          backgroundImage: `url(${headerImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
        aria-label="Blisspa - Pijat Muslim Muslimah Bandung Hero Section"
      >
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="relative z-10 max-w-4xl px-5">
          <div className="bg-white/20 backdrop-blur-xl border border-white/30 rounded-3xl p-8 md:p-12 shadow-2xl">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight text-white drop-shadow-lg leading-tight">
              <span className="block sm:inline">BRING OUR HALAL SPA</span>
              <span className="block sm:inline"> TO YOUR HOME</span>
            </h1>
            <p className="text-lg md:text-xl mb-10 text-white/90 leading-relaxed drop-shadow-md">Layanan <strong>home service massage Bandung</strong> dengan standar premium. <strong>Jasa pijat ke rumah</strong> yang aman dan terpercaya - terapis profesional sesuai gender, produk halal & natural, privasi terjaga. Nikmati relaksasi berkualitas di kenyamanan rumah Anda.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
  className="bg-white/30 backdrop-blur-md border border-white/40 text-white font-semibold px-10 py-4 text-lg rounded-2xl hover:bg-white/40 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 shadow-xl"
  onClick={() => {
    const phoneNumber = "6282289998442";
    const message = encodeURIComponent("Assalamu'alaikum, aku mau tanya ...");
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  }}
>
  Reservasi Sekarang!
</button>
              <button
  className="bg-white/30 backdrop-blur-md border border-white/40 text-white font-semibold px-10 py-4 text-lg rounded-2xl hover:bg-white/40 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 shadow-xl"
  onClick={() => {
    window.open("https://www.instagram.com/blisspa.halalhomespa", "_blank");
  }}
>
  Follow Instagram
</button>
            </div>
          </div>
        </div>
      </section>
      

      {/* Services Section */}
      <section id="services" className="py-20 bg-gradient-to-br from-[#F1EFF0]/50 via-[#A2D1BC]/30 to-[#70CAC6]/50 relative overflow-hidden">
        <div className="absolute inset-0 bg-white/30 backdrop-blur-sm"></div>
        <div className="max-w-6xl mx-auto px-5 relative z-10">
          {/* Promo Banner */}
          <div className="mt-12 bg-gradient-to-r from-[#F7BAD5]/30 to-[#70CAC6]/30 backdrop-blur-xl border border-white/40 rounded-3xl p-8 text-center shadow-2xl">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">🎉 DISKON!</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-white/50 rounded-2xl p-4">
                <h4 className="font-bold text-[#70A681] mb-2">Promo Blisspa Elite</h4>
                <p className="text-sm text-gray-600">Dapatkan diskon <span className="font-bold text-[#70A681]">10%</span> untuk layanan pertama dengan kode referral dari Blisspa Elite!</p>
              </div>
              <div className="bg-white/50 rounded-2xl p-4">
                <h4 className="font-bold text-[#70A681] mb-2">Promo Spesial Launching Website</h4>
                <p className="text-sm text-gray-600">Dapatkan diskon <span className="font-bold text-[#70A681]">10%</span> untuk layanan weekend bulan Oktober dengan pemesanan melalui form website!</p>
              </div>
            </div>
          </div>
          
          <div className="text-center mb-12 mt-16">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
              <MassageIcon className="inline text-[#70A681] mr-2" size={28} />
              Layanan Kami
              <SparkleIcon className="inline text-[#70CAC6] ml-2" size={28} />
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-[#70A681] to-[#A2D1BC] rounded-full mx-auto"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {/* Service 1 - Full Body Massage */}
            <div className="bg-white/40 backdrop-blur-xl border border-white/50 p-6 rounded-3xl text-center shadow-2xl hover:shadow-3xl hover:-translate-y-2 hover:bg-white/50 transition-all duration-300">
              <div className="flex justify-center mb-4">
                <MassageServiceImage size={64} className="rounded-lg shadow-md" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Full Body Massage</h3>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">Pijat seluruh tubuh untuk meredakan pegal, melancarkan peredaran darah, dan membuat badan terasa lebih segar dan rileks.</p>
              <div className="space-y-2">
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">90 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 140.000</span>
                </div>
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">120 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 185.000</span>
                </div>
              </div>
            </div>

            {/* Service*/}
            <div className="bg-white/40 backdrop-blur-xl border border-white/50 p-6 rounded-3xl text-center shadow-2xl hover:shadow-3xl hover:-translate-y-2 hover:bg-white/50 transition-all duration-300">
              <div className="flex justify-center mb-4">
                <ReflectionServiceImage size={64} className="rounded-lg shadow-md" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Reflection Massage</h3>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">Pijat refleksi pada titik-titik tertentu di telapak kaki yang membantu memperlancar energi tubuh, mengurangi stres, dan menyehatkan organ dalam.</p>
              <div className="space-y-2">
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">60 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 140.000</span>
                </div>
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">90 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 185.000</span>
                </div>
              </div>
            </div>

            {/* Service 3*/}
            <div className="bg-white/40 backdrop-blur-xl border border-white/50 p-6 rounded-3xl text-center shadow-2xl hover:shadow-3xl hover:-translate-y-2 hover:bg-white/50 transition-all duration-300">
              <div className="flex justify-center mb-4">
                <MassageServiceImage size={64} className="rounded-lg shadow-md" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Fullbody Massage + Reflection</h3>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">Kombinasi pijat seluruh tubuh dan refleksi. Cocok untuk kamu yang ingin relaksasi total sekaligus menjaga kesehatan tubuh.</p>
              <div className="space-y-2">
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">90 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 150.000</span>
                </div>
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">120 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 195.000</span>
                </div>
              </div>
            </div>

            {/* Service 4*/}
            <div className="bg-white/40 backdrop-blur-xl border border-white/50 p-6 rounded-3xl text-center shadow-2xl hover:shadow-3xl hover:-translate-y-2 hover:bg-white/50 transition-all duration-300">
              <div className="flex justify-center mb-4">
                <FaceServiceImage size={64} className="rounded-lg shadow-md" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Fullbody Massage + Face Massage</h3>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">Perpaduan pijat tubuh dan pijat wajah yang menenangkan otot-otot wajah, membuat kulit lebih segar, serta mengurangi ketegangan di area kepala dan leher.</p>
              <div className="space-y-2">
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">90 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 150.000</span>
                </div>
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">120 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 195.000</span>
                </div>
              </div>
            </div>

            {/* Service 5*/}
            <div className="bg-white/40 backdrop-blur-xl border border-white/50 p-6 rounded-3xl text-center shadow-2xl hover:shadow-3xl hover:-translate-y-2 hover:bg-white/50 transition-all duration-300">
              <div className="flex justify-center mb-4">
                <CuppingServiceImage size={64} className="rounded-lg shadow-md" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Fullbody Massage + Cupping Massage (Bekam Basah)</h3>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">Kombinasi pijat tubuh dengan bekam basah untuk mengeluarkan racun dari tubuh, melancarkan peredaran darah, dan meningkatkan vitalitas.</p>
              <div className="space-y-2">
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">90 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 270.000</span>
                </div>
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">120 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 320.000</span>
                </div>
              </div>
            </div>

            {/* Service 6 */}
            <div className="bg-white/40 backdrop-blur-xl border border-white/50 p-6 rounded-3xl text-center shadow-2xl hover:shadow-3xl hover:-translate-y-2 hover:bg-white/50 transition-all duration-300">
              <div className="flex justify-center mb-4">
                <CuppingServiceImage size={64} className="rounded-lg shadow-md" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Fullbody Massage + Cupping Massage (Bekam Kering)</h3>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">Perawatan dengan teknik bekam kering yang dikombinasikan dengan pijat tubuh. Membantu meredakan pegal, meningkatkan energi, dan memperbaiki sirkulasi tanpa sayatan.</p>
              <div className="space-y-2">
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">90 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 150.000</span>
                </div>
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">120 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 195.000</span>
                </div>
              </div>
            </div>

            {/* Service 7*/}
            <div className="bg-white/40 backdrop-blur-xl border border-white/50 p-6 rounded-3xl text-center shadow-2xl hover:shadow-3xl hover:-translate-y-2 hover:bg-white/50 transition-all duration-300">
              <div className="flex justify-center mb-4">
                <KretekServiceImage size={64} className="rounded-lg shadow-md" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Fullbody Massage + Injury Massage</h3>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">Pijat tubuh menyeluruh dengan teknik kretek untuk meluruskan sendi, meredakan pegal, dan bikin badan terasa lebih ringan.</p>
              <div className="space-y-2">
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">60 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 240.000</span>
                </div>
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">120 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 290.000</span>
                </div>
              </div>
            </div>

            {/* Service 8*/}
            <div className="bg-white/40 backdrop-blur-xl border border-white/50 p-6 rounded-3xl text-center shadow-2xl hover:shadow-3xl hover:-translate-y-2 hover:bg-white/50 transition-all duration-300">
              <div className="flex justify-center mb-4">
                <StoneServiceImage size={64} className="rounded-lg shadow-md" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Fullbody Massage + Hot stone</h3>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">Pijat tubuh menggunakan batu panas yang diletakkan pada titik-titik tertentu. Membantu merilekskan otot, melancarkan sirkulasi darah, serta memberikan rasa hangat yang menenangkan.</p>
              <div className="space-y-2">
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">90 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 200.000</span>
                </div>
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">120 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 245.000</span>
                </div>
              </div>
            </div>

            {/* Service 9 */}
            <div className="bg-white/40 backdrop-blur-xl border border-white/50 p-6 rounded-3xl text-center shadow-2xl hover:shadow-3xl hover:-translate-y-2 hover:bg-white/50 transition-all duration-300">
              <div className="flex justify-center mb-4">
                <ScrappingServiceImage size={64} className="rounded-lg shadow-md" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Fullbody Massage + Scrapping (Kerok)</h3>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">Kombinasi pijat tubuh dengan teknik kerokan tradisional untuk meredakan masuk angin, melancarkan peredaran darah, dan membuat badan terasa lebih enteng.</p>
              <div className="space-y-2">
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">90 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 150.000</span>
                </div>
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">120 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 195.000</span>
                </div>
              </div>
            </div>

            {/* Service 10 */}
            <div className="bg-white/40 backdrop-blur-xl border border-white/50 p-6 rounded-3xl text-center shadow-2xl hover:shadow-3xl hover:-translate-y-2 hover:bg-white/50 transition-all duration-300">
              <div className="flex justify-center mb-4">
                <ScrubServiceImage size={64} className="rounded-lg shadow-md" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Fullbody Massage + Scrub</h3>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">Pijat tubuh yang dipadukan dengan scrub lembut untuk membersihkan kulit secara menyeluruh, membuat kulit terasa lebih halus, segar, dan bercahaya.</p>
              <div className="space-y-2">
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">90 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 150.000</span>
                </div>
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">120 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 195.000</span>
                </div>
              </div>
            </div>

            {/* Service 11 - Kids Massage */}
            <div className="bg-white/40 backdrop-blur-xl border border-white/50 p-6 rounded-3xl text-center shadow-2xl hover:shadow-3xl hover:-translate-y-2 hover:bg-white/50 transition-all duration-300">
              <div className="flex justify-center mb-4">
                <KidsMassageServiceImage size={64} className="rounded-lg shadow-md" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Kids Massage</h3>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">Pijat khusus anak dengan teknik lembut dan aman untuk membantu tubuh mereka lebih rileks, tidur lebih nyenyak, serta meningkatkan daya tahan tubuh.</p>
              <div className="space-y-2">
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">45 menit</span>
                  <span className="text-lg font-bold text-[#70A681]">Rp 80.000</span>
                </div>
                
              </div>
            </div>

            {/* Service 11 */}
            {/* <div className="bg-white/40 backdrop-blur-xl border border-white/50 p-6 rounded-3xl text-center shadow-2xl hover:shadow-3xl hover:-translate-y-2 hover:bg-white/50 transition-all duration-300">
              <div className="text-4xl mb-4">🎁</div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Weekend Massage</h3>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">Nikmati pijat relaksasi untuk menutup hari penatmu selama bekerja di weekend!</p>
              <div className="space-y-2">
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">90 menit</span>
                  <div className="text-right">
                    <div className="text-xs text-gray-500 line-through">Rp 280.000</div>
                    <span className="text-lg font-bold text-[#70A681]">Rp 265.000</span>
                  </div>
                </div>
                <div className="flex justify-between items-center bg-[#F1EFF0]/50 rounded-xl p-3">
                  <span className="text-sm font-medium">120 menit</span>
                  <div className="text-right">
                    <div className="text-xs text-gray-500 line-through">Rp 370.000</div>
                    <span className="text-lg font-bold text-[#70A681]">Rp 355.000</span>
                  </div>
                </div>
              </div>
              <div className="mt-3 bg-[#F7BAD5]/20 rounded-lg p-2">
                <span className="text-xs text-[#70A681] font-semibold">💰 Special Bundle Discount!</span>
              </div>
            </div> */}
            
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-gradient-to-br from-[#F7BAD5]/50 via-[#F1EFF0]/30 to-[#A2D1BC]/50 relative overflow-hidden">
        <div className="absolute inset-0 bg-white/30 backdrop-blur-sm"></div>
        <div className="max-w-6xl mx-auto px-5 relative z-10">
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">Tentang Blisspa</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-[#F7BAD5] to-[#70CAC6] rounded-full mx-auto"></div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="bg-white/30 backdrop-blur-xl border border-white/40 rounded-3xl p-8 shadow-2xl">
              <h3 className="text-2xl font-bold mb-6 text-gray-800">Mengapa Blisspa Berbeda?</h3>
              <p className="text-gray-600 mb-6 text-lg leading-relaxed">
                Blisspa adalah <strong>pijat panggilan Bandung terpercaya</strong> yang mengutamakan profesionalisme dan kenyamanan. Kami memahami kekhawatiran Anda tentang layanan <strong>home service massage</strong> - itulah mengapa kami berkomitmen memberikan pengalaman yang aman, bersih, dan professional.
              </p>
              <p className="text-gray-600 text-lg leading-relaxed">
                <strong>Standar Keamanan Tinggi:</strong> Terapis bersertifikat sesuai gender, produk halal & natural berkualitas premium, protokol kebersihan ketat. Privasi dan kenyamanan Anda adalah prioritas utama kami.
              </p>
              <p className="text-gray-600 text-lg leading-relaxed">💖 Blisspa - Wellness yang aman dan terpercaya untuk semua kalangan.</p>
            </div>
            <div className="space-y-6">
              <div className="p-6 bg-gray-50 rounded-xl border-l-4 border-primary-500">
                <h4 className="text-xl font-semibold mb-2 text-gray-800">👥 Terapis Sesuai Gender</h4>
                <p className="text-gray-600">Terapis pria khusus untuk klien pria, terapis wanita khusus untuk klien wanita. Privasi dan kenyamanan Anda terjaga sepenuhnya.</p>
              </div>
              <div className="p-6 bg-gray-50 rounded-xl border-l-4 border-primary-500">
                <h4 className="text-xl font-semibold mb-2 text-gray-800">🌿 Produk Halal & Natural</h4>
                <p className="text-gray-600">Menggunakan produk berkualitas premium yang halal dan natural. Aman untuk semua jenis kulit dan memberikan hasil optimal.</p>
              </div>
              <div className="p-6 bg-gray-50 rounded-xl border-l-4 border-primary-500">
                <h4 className="text-xl font-semibold mb-2 text-gray-800">🔒 Standar Profesional</h4>
                <p className="text-gray-600">Terapis bersertifikat dengan protokol keamanan ketat. Layanan terpercaya dengan standar kebersihan dan profesionalisme tinggi.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="py-20 bg-gradient-to-br from-[#F7BAD5]/50 via-[#F1EFF0]/30 to-[#A2D1BC]/50 relative overflow-hidden">
        <div className="absolute inset-0 bg-white/30 backdrop-blur-sm"></div>
        <div className="max-w-6xl mx-auto px-5 relative z-10">
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
              💬 Cerita dari Mereka ⭐
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-[#F7BAD5] to-[#70CAC6] rounded-full mx-auto"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full flex items-center justify-center text-white font-bold text-xl">
                  S
                </div>
                <div className="ml-4">
                  <h4 className="text-lg font-semibold text-gray-800">Risya, Parongpong</h4>
                  <div className="flex text-yellow-400 text-sm">
                    ★★★★★
                  </div>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed italic">
                
"Pengalaman pertama pesan homespa dan langsung puas! Pijatannya nyaman, adminnya sangat responsif, dan sebagai muslimah sekaligus ibu rumah tangga saya merasa lebih tenang karena bisa menikmati layanan tanpa harus keluar rumah. Layanan ini pasti akan jadi langganan saya."

              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full flex items-center justify-center text-white font-bold text-xl">
                  G
                </div>
                <div className="ml-4">
                  <h4 className="text-lg font-semibold text-gray-800">Ghaitsa, Gedebage</h4>
                  <div className="flex text-yellow-400 text-sm">
                    ★★★★★
                  </div>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed italic">
                "Setelah seminggu dipijat, badannya udah ga pegel-pegel lagi. Pijatannya lebih enak dari sebelumnya pernah pake jasa blisspa juga.... Besok2 kalau mau pijet aku request terapisnya dengan ibu Yanti yaaa."
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full flex items-center justify-center text-white font-bold text-xl">
                  C
                </div>
                <div className="ml-4">
                  <h4 className="text-lg font-semibold text-gray-800">Chimey, Buahbatu</h4>
                  <div className="flex text-yellow-400 text-sm">
                    ★★★★★
                  </div>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed italic">
                "Best spa experience I've ever had! The body wrap was so relaxing and therapeutic. 
                The ambiance is perfect and the products they use are top quality. Highly recommend!"
              </p>
            </div>
          </div>
        </div>
        
          {/* Add Testimonial Form */}
          <div className="mt-16 bg-white/40 backdrop-blur-xl border border-white/50 rounded-3xl p-8 shadow-2xl max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-800 mb-8 text-center">🌟 Bagikan Pengalaman Spa Kamu! ✨</h3>
            <p className="text-center text-gray-600 mb-8">Ceritakan pengalaman spa-mu bersama Blisspa dan bantu orang lain menemukan momen relaksasi yang sempurna!</p>
            
            <form onSubmit={handleTestimonialSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nama kamu *</label>
                <input 
                  type="text" 
                  name="name"
                  value={testimonialData.name}
                  onChange={handleTestimonialInputChange}
                  placeholder="Tulis nama lengkap kamu" 
                  className="w-full p-4 rounded-xl bg-white/80 backdrop-blur-md border border-gray-300 text-gray-800 placeholder-gray-500 focus:outline-none focus:border-[#70A681] focus:ring-2 focus:ring-[#70A681]/30 transition-all duration-300 shadow-sm" 
                  required 
                />
              </div>
              
              {/* Star Rating */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-3">Berapa bintang untuk pengalaman spa-mu? *</label>
                <div className="flex space-x-2 mb-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <button
                      key={star}
                      type="button"
                      onClick={() => handleStarRating(star)}
                      className={`text-3xl transition-all duration-200 hover:scale-110 ${
                        star <= testimonialData.rating ? 'text-yellow-400' : 'text-gray-300'
                      }`}
                    >
                      ★
                    </button>
                  ))}
                </div>
                <p className="text-sm text-gray-500">
                  {testimonialData.rating === 0 && "Klik bintang untuk memberikan rating"}
                  {testimonialData.rating === 1 && "⭐ Kurang puas"}
                  {testimonialData.rating === 2 && "⭐⭐ Cukup"}
                  {testimonialData.rating === 3 && "⭐⭐⭐ Baik"}
                  {testimonialData.rating === 4 && "⭐⭐⭐⭐ Sangat baik"}
                  {testimonialData.rating === 5 && "⭐⭐⭐⭐⭐ Luar biasa!"}
                </p>
              </div>
              
              {/* Pre-written Options */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-3">Pilih yang sesuai dengan pengalaman kamu:</label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {[
                    'Pijatannya enak banget',
                    'Terapis datang tepat waktu', 
                    'Pelayanan sangat ramah',
                    'Harga terjangkau',
                    'Produk halal dan berkualitas',
                    'Suasana rileks dan nyaman',
                    'Terapis profesional',
                    'Pegal-pegal hilang semua',
                    'Badan jadi segar',
                    'Recommended banget!'
                  ].map((option) => (
                    <label key={option} className="flex items-center space-x-3 p-3 rounded-xl bg-white/60 hover:bg-white/80 transition-all duration-200 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={testimonialData.selectedOptions.includes(option)}
                        onChange={() => handleTestimonialOptionChange(option)}
                        className="w-4 h-4 text-[#70A681] bg-gray-100 border-gray-300 rounded focus:ring-[#70A681] focus:ring-2"
                      />
                      <span className="text-gray-700 text-sm">{option}</span>
                    </label>
                  ))}
                </div>
              </div>
              
              {/* Custom Text */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Cerita tambahan (opsional)</label>
                <textarea 
                  name="customText"
                  value={testimonialData.customText}
                  onChange={handleTestimonialInputChange}
                  placeholder="Tulis pengalaman spa-mu yang belum tercakup di atas..." 
                  rows={4}
                  className="w-full p-4 rounded-xl bg-white/80 backdrop-blur-md border border-gray-300 text-gray-800 placeholder-gray-500 focus:outline-none focus:border-[#70A681] focus:ring-2 focus:ring-[#70A681]/30 resize-none transition-all duration-300 shadow-sm"
                ></textarea>
              </div>
              
              {/* Preview */}
              {(testimonialData.selectedOptions.length > 0 || testimonialData.customText) && (
                <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-[#70A681]">
                  <h4 className="font-medium text-gray-700 mb-2">Preview testimoni kamu:</h4>
                  <p className="text-gray-600 italic">
                    "{testimonialData.selectedOptions.length > 0 && testimonialData.customText 
                      ? `${testimonialData.selectedOptions.join(', ')}. ${testimonialData.customText}`
                      : testimonialData.selectedOptions.join(', ') || testimonialData.customText}"
                  </p>
                </div>
              )}
              
              <button 
                type="submit" 
                disabled={!testimonialData.name || testimonialData.rating === 0 || (testimonialData.selectedOptions.length === 0 && !testimonialData.customText)}
                className="w-full bg-gradient-to-r from-[#70A681] to-[#A2D1BC] text-white p-4 text-lg font-semibold rounded-xl hover:from-[#5a8a6b] hover:to-[#8bc4a7] hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:transform-none"
              >
                🌟 Kirim Testimoni
              </button>
              
              <p className="text-sm text-gray-600 text-center">
                Testimoni kamu akan dikirim ke WhatsApp kami dan membantu orang lain menemukan layanan spa terbaik! 💕
              </p>
            </form>
          </div>
      </section>

      {/* Therapist Section */}
      <section id="therapist" className="py-20 bg-gradient-to-br from-[#70A681]/50 via-[#F1EFF0]/30 to-[#F7BAD5]/50 relative overflow-hidden">
        {/* Animated Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-32 h-32 bg-gradient-to-r from-[#70A681]/20 to-[#F7BAD5]/20 rounded-full animate-bounce delay-0"></div>
          <div className="absolute top-20 right-20 w-24 h-24 bg-gradient-to-r from-[#F7BAD5]/20 to-[#70CAC6]/20 rounded-full animate-bounce delay-300"></div>
          <div className="absolute bottom-20 left-20 w-20 h-20 bg-gradient-to-r from-[#70CAC6]/20 to-[#A2D1BC]/20 rounded-full animate-bounce delay-700"></div>
          <div className="absolute bottom-10 right-10 w-28 h-28 bg-gradient-to-r from-[#A2D1BC]/20 to-[#70A681]/20 rounded-full animate-bounce delay-1000"></div>
        </div>
        <div className="absolute inset-0 bg-white/30 backdrop-blur-sm"></div>
        <div className="max-w-7xl mx-auto px-5 relative z-10">
          {/* Award Banner */}
          <div className="text-center mb-12">
            <div className="inline-block bg-gradient-to-r from-[#70A681] to-[#F7BAD5] text-white px-8 py-3 rounded-full text-lg font-bold mb-6 shadow-lg hover:scale-105 transition-all duration-300 animate-pulse">
              🏆 THERAPIST OF THE YEAR 2025 🏆
            </div>
            
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              <UserIcon className="inline text-[#70A681] mr-2" size={28} />
              Meet Our Best Therapists
              <HeartIcon className="inline text-[#F7BAD5] ml-2" size={28} />
            </h2>
            
            <div className="max-w-5xl mx-auto bg-white/50 backdrop-blur-xl border border-white/60 rounded-3xl p-8 shadow-2xl">
              <p className="text-xl text-gray-800 leading-relaxed font-medium">
                🎆 <strong className="text-[#70A681]">Penghargaan Bergengsi!</strong> Kami dengan bangga memperkenalkan terapis-terapis terbaik yang telah terpilih sebagai 
                <span className="bg-gradient-to-r from-[#70A681] to-[#F7BAD5] bg-clip-text text-transparent font-bold text-2xl">
                  "Therapist of the Year 2025"
                </span>
                atas dedikasi luar biasa, keahlian profesional, dan pelayanan terdepan sepanjang tahun! 💖
              </p>
            </div>
          </div>
          
          {/* Therapist Cards */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
            {/* Therapist 1 - Sulaeman */}
            <div className="group relative">
              <div className="absolute inset-0 bg-gradient-to-r from-[#70A681] to-[#A2D1BC] rounded-3xl opacity-20 group-hover:opacity-30 transition-opacity duration-300 animate-pulse"></div>
              
              <div className="relative bg-white/70 backdrop-blur-xl border-2 border-white/80 rounded-3xl p-8 shadow-2xl hover:shadow-3xl hover:-translate-y-3 transition-all duration-500 group-hover:bg-white/85">
                {/* Award Badge */}
                <div className="absolute -top-4 -right-4 bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg transform rotate-12 group-hover:rotate-0 transition-transform duration-300">
                  🏆 #1 MALE THERAPIST
                </div>
                
                {/* Profile Section */}
                <div className="text-center mb-6">
                  <div className="relative mb-6">
                    <div className="w-40 h-40 mx-auto rounded-full shadow-2xl group-hover:scale-110 transition-all duration-500 border-4 border-white/50 overflow-hidden">
                      <img src={pakImanImage} alt="Pak Sulaeman - Terapis Muslim Terbaik Bandung" className="w-full h-full object-cover" />
                    </div>
                    <div className="absolute -bottom-2 -right-2 bg-gradient-to-r from-green-400 to-blue-500 text-white px-3 py-1 rounded-full text-xs font-bold animate-bounce">
                      8+ Years
                    </div>
                  </div>
                  
                  <h3 className="text-3xl font-black text-gray-800 mb-2 group-hover:text-[#70A681] transition-colors duration-300">
                    Pak Sulaeman
                  </h3>
                  <p className="text-[#70A681] font-bold text-lg mb-4">Master Therapist | Bandung</p>
                </div>
                
                {/* Specialties */}
                <div className="mb-6">
                  <h4 className="text-lg font-bold text-gray-800 mb-3 text-center">
                    🌟 Keahlian Spesial:
                  </h4>
                  <div className="flex flex-wrap justify-center gap-2">
                    {['Full Body Massage', 'Reflexy', 'Totok Wajah', 'Scrub', 'Hot Stone', 'Bekam Kering'].map((skill) => (
                      <span key={skill} className="bg-gradient-to-r from-[#70A681]/20 to-[#A2D1BC]/20 px-3 py-1 rounded-full text-sm font-semibold text-gray-700 border border-[#70A681]/30 hover:scale-105 transition-transform duration-200">
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
                
                {/* Description */}
                <div className="bg-gradient-to-r from-[#70A681]/10 to-[#A2D1BC]/10 rounded-2xl p-6 border-l-4 border-[#70A681] mb-4">
                  <p className="text-gray-700 text-base leading-relaxed text-left">
                    💪 <strong>Pengalaman Sejak 2016!</strong> Pak Iman adalah terapis senior dengan sertifikasi dari Maxim & Kims Therapy. 
                    Keahliannya yang menyeluruh dalam berbagai teknik pijat membuatnya menjadi pilihan utama untuk relaksasi maksimal. 
                    Setiap sentuhan tekniknya dirancang khusus untuk memberikan kelegaan dan kesegaran bagi tubuh Anda.
                  </p>
                </div>
                
                {/* Rating */}
                <div className="flex justify-center items-center space-x-2">
                  <div className="flex space-x-1">
                    {[1,2,3,4,5].map((star) => (
                      <span key={star} className="text-2xl text-yellow-400">★</span>
                    ))}
                  </div>
                  <span className="text-gray-600 font-semibold">(5.0/5)</span>
                </div>
              </div>
            </div>
            
            {/* Therapist 2 - Yanti Suryanti */}
            <div className="group relative">
              <div className="absolute inset-0 bg-gradient-to-r from-[#F7BAD5] to-[#70CAC6] rounded-3xl opacity-20 group-hover:opacity-30 transition-opacity duration-300 animate-pulse"></div>
              
              <div className="relative bg-white/70 backdrop-blur-xl border-2 border-white/80 rounded-3xl p-8 shadow-2xl hover:shadow-3xl hover:-translate-y-3 transition-all duration-500 group-hover:bg-white/85">
                {/* Award Badge */}
                <div className="absolute -top-4 -right-4 bg-gradient-to-r from-pink-400 to-purple-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg transform -rotate-12 group-hover:rotate-0 transition-transform duration-300">
                  🏆 #1 FEMALE THERAPIST
                </div>
                
                {/* Profile Section */}
                <div className="text-center mb-6">
                  <div className="relative mb-6">
                    <div className="w-40 h-40 mx-auto rounded-full shadow-2xl group-hover:scale-110 transition-all duration-500 border-4 border-white/50 overflow-hidden">
                      <img src={buYantiImage} alt="Bu Yanti Suryanti - Terapis Muslimah Terbaik Bandung" className="w-full h-full object-cover" />
                    </div>
                    <div className="absolute -bottom-2 -right-2 bg-gradient-to-r from-pink-400 to-purple-500 text-white px-3 py-1 rounded-full text-xs font-bold animate-bounce">
                      6+ Years
                    </div>
                  </div>
                  
                  <h3 className="text-3xl font-black text-gray-800 mb-2 group-hover:text-[#F7BAD5] transition-colors duration-300">
                    Bu Yanti Suryanti
                  </h3>
                  <p className="text-[#F7BAD5] font-bold text-lg mb-4">Master Therapist | Cileunyi, Bandung</p>
                </div>
                
                {/* Specialties */}
                <div className="mb-6">
                  <h4 className="text-lg font-bold text-gray-800 mb-3 text-center">
                    🌟 Keahlian Spesial:
                  </h4>
                  <div className="flex flex-wrap justify-center gap-2">
                    {['Full Body Massage', 'Reflexy', 'Totok Wajah', 'Prenatal Massage', 'Aromatherapy'].map((skill) => (
                      <span key={skill} className="bg-gradient-to-r from-[#F7BAD5]/20 to-[#70CAC6]/20 px-3 py-1 rounded-full text-sm font-semibold text-gray-700 border border-[#F7BAD5]/30 hover:scale-105 transition-transform duration-200">
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
                
                {/* Description */}
                <div className="bg-gradient-to-r from-[#F7BAD5]/10 to-[#70CAC6]/10 rounded-2xl p-6 border-l-4 border-[#F7BAD5] mb-4">
                  <p className="text-gray-700 text-base leading-relaxed text-left">
                    🌸 <strong>6 Tahun Pengalaman Tersertifikasi!</strong> Bu Yanti adalah terapis wanita terbaik dengan keahlian luar biasa 
                    dalam full body massage, reflexy, dan totok wajah. Sentuhan lembutnya yang presisi dan teknik yang selalu tepat sasaran 
                    membuatnya sangat diandalkan. Selamat atas penghargaan yang sangat layak ini!
                  </p>
                </div>
                
                {/* Rating */}
                <div className="flex justify-center items-center space-x-2">
                  <div className="flex space-x-1">
                    {[1,2,3,4,5].map((star) => (
                      <span key={star} className="text-2xl text-yellow-400">★</span>
                    ))}
                  </div>
                  <span className="text-gray-600 font-semibold">(5.0/5)</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Why Choose Our Elite Therapists 
          <div className="bg-gradient-to-r from-white/60 to-white/40 backdrop-blur-xl border border-white/60 rounded-3xl p-10 shadow-2xl">
            <div className="text-center mb-10">
              <h3 className="text-3xl font-black text-gray-800 mb-4">
                ✨ Mengapa Memilih Terapis Elite Kami? ✨
              </h3>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Penghargaan ini bukan hanya sekedar gelar, tapi bukti nyata komitmen kami terhadap excellence!
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div className="text-center group hover:-translate-y-2 transition-all duration-300">
                <div className="w-20 h-20 bg-gradient-to-br from-[#70A681] to-[#A2D1BC] rounded-full flex items-center justify-center text-3xl mx-auto mb-4 shadow-xl group-hover:scale-110 transition-all duration-300">
                  🏆
                </div>
                <h4 className="text-xl font-bold text-gray-800 mb-2">Tersertifikasi</h4>
                <p className="text-gray-600 text-sm leading-relaxed">Sertifikasi resmi dari institusi terapi terpercaya dengan pengalaman 6+ tahun</p>
              </div>
              
              <div className="text-center group hover:-translate-y-2 transition-all duration-300">
                <div className="w-20 h-20 bg-gradient-to-br from-[#F7BAD5] to-[#70CAC6] rounded-full flex items-center justify-center text-3xl mx-auto mb-4 shadow-xl group-hover:scale-110 transition-all duration-300">
                  ⏰
                </div>
                <h4 className="text-xl font-bold text-gray-800 mb-2">Tepat Waktu</h4>
                <p className="text-gray-600 text-sm leading-relaxed">Komitmen punctuality 100% - tidak pernah terlambat dari janji yang disepakati</p>
              </div>
              
              <div className="text-center group hover:-translate-y-2 transition-all duration-300">
                <div className="w-20 h-20 bg-gradient-to-br from-[#70CAC6] to-[#A2D1BC] rounded-full flex items-center justify-center text-3xl mx-auto mb-4 shadow-xl group-hover:scale-110 transition-all duration-300">
                  💖
                </div>
                <h4 className="text-xl font-bold text-gray-800 mb-2">Service Excellence</h4>
                <p className="text-gray-600 text-sm leading-relaxed">Rating sempurna 5.0/5 dengan pelayanan ramah dan profesional</p>
              </div>
              
              <div className="text-center group hover:-translate-y-2 transition-all duration-300">
                <div className="w-20 h-20 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center text-3xl mx-auto mb-4 shadow-xl group-hover:scale-110 transition-all duration-300">
                  🎆
                </div>
                <h4 className="text-xl font-bold text-gray-800 mb-2">Award Winner</h4>
                <p className="text-gray-600 text-sm leading-relaxed">Pemenang "Therapist of the Year 2025" berdasarkan performa terbaik</p>
              </div>
            </div>
            
            {/* Call to Action 
            <div className="mt-10 text-center">
              <div className="bg-gradient-to-r from-[#70A681] to-[#F7BAD5] text-white px-8 py-4 rounded-2xl inline-block shadow-lg hover:scale-105 transition-all duration-300 cursor-pointer"
                   onClick={() => {
                     const phoneNumber = "6282289998442";
                     const message = encodeURIComponent("Halo! Saya tertarik untuk booking dengan Therapist of the Year. Bisa info lebih lanjut?");
                     window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
                   }}>
                <p className="text-lg font-bold mb-2">📞 Book Terapis Terbaik Blisspa Sekarang!</p>
                <p className="text-sm opacity-90">Rasakan pengalaman spa dengan pemenang Therapist of the Year 2025</p>
              </div>
            </div>
          </div>*/}
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-20 bg-gradient-to-br from-[#70CAC6]/50 via-[#F1EFF0]/30 to-[#A2D1BC]/50 relative overflow-hidden">
        <div className="absolute inset-0 bg-white/30 backdrop-blur-sm"></div>
        <div className="max-w-4xl mx-auto px-5 relative z-10">
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
              ❓ FAQ 💡
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-[#70CAC6] to-[#A2D1BC] rounded-full mx-auto"></div>
          </div>
          <div className="space-y-6">
            <div className="bg-gray-50 rounded-xl p-6 border-l-4 border-primary-500">
              <h3 className="text-xl font-semibold mb-3 text-gray-800">Apakah layanan Blisspa dapat dipesan untuk hari H?</h3>
              <p className="text-gray-600 leading-relaxed">
                Bisa apabila terapis tersedia di hari tersebut.
              </p>
            </div>
            <div className="bg-gray-50 rounded-xl p-6 border-l-4 border-primary-500">
              <h3 className="text-xl font-semibold mb-3 text-gray-800">Apakah saya bisa melakukan refund?</h3>
              <p className="text-gray-600 leading-relaxed">
                Tidak bisa namun apabila pelanggan berhalangan di waktu yang telah disepakati, perubahan jadwal dapat dilakukan.
              </p>
            </div>
            <div className="bg-gray-50 rounded-xl p-6 border-l-4 border-primary-500">
              <h3 className="text-xl font-semibold mb-3 text-gray-800">Bagaimana cara saya membayar pesanan?</h3>
              <p className="text-gray-600 leading-relaxed">
                Dapat melalu transfer ke Bank Jago 502596962414 a.n Hasna Karimah atau cash ke terapis dengan wajib  konfirmasi melalui CS.
              </p>
            </div>
            <div className="bg-gray-50 rounded-xl p-6 border-l-4 border-primary-500">
              <h3 className="text-xl font-semibold mb-3 text-gray-800">Bagaimana cara untuk bergabung menjadi member?</h3>
              <p className="text-gray-600 leading-relaxed">
                Untuk bergabung menjadi member dapat mendaftar melalui CS Blisspa.
              </p>
            </div>
            <div className="bg-gray-50 rounded-xl p-6 border-l-4 border-primary-500">
              <h3 className="text-xl font-semibold mb-3 text-gray-800">Apa kelebihan bergabung menjadi member Blisspa?</h3>
              <p className="text-gray-600 leading-relaxed">
                 Kelebihannya pelanggan dapat menikmati layanan gratis dari blisspa setelah target tercapai.
              </p>
            </div>
            <div className="bg-gray-50 rounded-xl p-6 border-l-4 border-primary-500">
              <h3 className="text-xl font-semibold mb-3 text-gray-800">Apakah Blisspa memiliki outlet yang dapat dikunjungi langsung?</h3>
              <p className="text-gray-600 leading-relaxed">
                Saat ini Blisspa hanya bisa dilakukan dengan layanan homecare.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-gradient-to-br from-[#A2D1BC]/50 via-[#F1EFF0]/30 to-[#70A681]/50 relative overflow-hidden">
        <div className="absolute inset-0 bg-white/30 backdrop-blur-sm"></div>
        <div className="max-w-6xl mx-auto px-5 relative z-10">
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
              📞 Hubungi Kami 📧
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-[#A2D1BC] to-[#70CAC6] rounded-full mx-auto mb-4"></div>
            <p className="text-gray-700 max-w-2xl mx-auto">
              Siap merasakan <strong>pijat panggilan Bandung terpercaya</strong>? Tim terapis profesional kami siap memberikan layanan <strong>home service massage</strong> berkualitas premium. Konsultasi gratis untuk layanan yang tepat sesuai kebutuhan Anda. Melayani area <strong>Bandung</strong> dan sekitarnya.
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div className="bg-white/40 backdrop-blur-xl border border-white/50 rounded-3xl p-8 shadow-2xl">
              <h3 className="text-2xl font-bold text-gray-800 mb-8 text-center">Tetap Bersama Kami</h3>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-[#70A681] to-[#A2D1BC] rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg">
                    <InstagramIcon className="text-[#FFFFFF] flex-shrink-0" size={30} />
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold mb-2 text-gray-800">Instagram</h4>
                    <p className="text-gray-600">@blisspa.halalhomespa</p>
                    <p className="text-gray-600">DM untuk respon cepat</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-[#70A681] to-[#A2D1BC] rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg">
                    📞
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold mb-2 text-gray-800">Whatsapp</h4>
                    <p className="text-gray-600">0822-8999-8442</p>
                    <p className="text-gray-600">Pemesanan lewat sini</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-[#70A681] to-[#A2D1BC] rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg">
                    🕒
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold mb-2 text-gray-800">Jam Operasional</h4>
                    <div className="text-gray-600 space-y-1">
                      <p><span className="font-medium">Senin - Minggu:</span> 08:00 - 22:00</p>
                    </div>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-[#70A681] to-[#A2D1BC] rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg">
                    📧
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold mb-2 text-gray-800">Email Kami</h4>
                    <p className="text-gray-600">blisspa.customercare@gmail.com</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-[#70A681] to-[#A2D1BC] rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg">
                    📍
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold mb-2 text-gray-800">Area Layanan</h4>
                    <p className="text-gray-600">Bandung dan sekitarnya</p>
                    <p className="text-gray-600 text-sm">Homecare service area</p>
                  </div>
                </div>
              </div>
              
              {/* Social Media */}
              <div className="mt-8 pt-6 border-t border-gray-200 ">
                <InstagramWidget />
              </div>
            </div>
            
            {/* Contact Form */}
            <div className="bg-white/40 backdrop-blur-xl border border-white/50 rounded-3xl p-8 shadow-2xl">
              <h3 className="text-2xl font-bold text-gray-800 mb-8 text-center">Kirim Pesan pada Kami</h3>
              <form className="space-y-6" onSubmit={handleSubmit}>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Nama kamu *</label>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Tulis nama lengkap kamu" 
                    className="w-full p-4 rounded-xl bg-white/80 backdrop-blur-md border border-gray-300 text-gray-800 placeholder-gray-500 focus:outline-none focus:border-[#70A681] focus:ring-2 focus:ring-[#70A681]/30 transition-all duration-300 shadow-sm" 
                    required 
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Tanggal Layanan *</label>
                  <input 
                    type="date" 
                    name="serviceDate"
                    value={formData.serviceDate}
                    onChange={handleInputChange}
                    className="w-full p-4 rounded-xl bg-white/80 backdrop-blur-md border border-gray-300 text-gray-800 placeholder-gray-500 focus:outline-none focus:border-[#70A681] focus:ring-2 focus:ring-[#70A681]/30 transition-all duration-300 shadow-sm" 
                    required 
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Jenis Kelamin *</label>
                  <div className="flex space-x-6 mt-2">
                    <label className="flex items-center">
                      <input 
                        type="radio" 
                        name="gender"
                        value="Laki-laki"
                        checked={formData.gender === 'Laki-laki'}
                        onChange={handleInputChange}
                        className="mr-2 text-[#70A681] focus:ring-[#70A681] focus:ring-2" 
                        required
                      />
                      <span className="text-gray-700">Laki-laki</span>
                    </label>
                    <label className="flex items-center">
                      <input 
                        type="radio" 
                        name="gender"
                        value="Perempuan"
                        checked={formData.gender === 'Perempuan'}
                        onChange={handleInputChange}
                        className="mr-2 text-[#70A681] focus:ring-[#70A681] focus:ring-2" 
                        required
                      />
                      <span className="text-gray-700">Perempuan</span>
                    </label>
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Alamat *</label>
                  <textarea 
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    placeholder="Tulis alamat lengkap untuk layanan homecare" 
                    rows={3}
                    className="w-full p-4 rounded-xl bg-white/80 backdrop-blur-md border border-gray-300 text-gray-800 placeholder-gray-500 focus:outline-none focus:border-[#70A681] focus:ring-2 focus:ring-[#70A681]/30 resize-none transition-all duration-300 shadow-sm" 
                    required
                  ></textarea>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Waktu Reservasi *</label>
                  <input 
                    type="time" 
                    name="reservationTime"
                    value={formData.reservationTime}
                    onChange={handleInputChange}
                    className="w-full p-4 rounded-xl bg-white/80 backdrop-blur-md border border-gray-300 text-gray-800 placeholder-gray-500 focus:outline-none focus:border-[#70A681] focus:ring-2 focus:ring-[#70A681]/30 transition-all duration-300 shadow-sm" 
                    required 
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Jumlah Orang *</label>
                  <input 
                    type="number" 
                    name="numberOfPeople"
                    value={formData.numberOfPeople}
                    onChange={handleInputChange}
                    min="1"
                    placeholder="Masukkan jumlah orang" 
                    className="w-full p-4 rounded-xl bg-white/80 backdrop-blur-md border border-gray-300 text-gray-800 placeholder-gray-500 focus:outline-none focus:border-[#70A681] focus:ring-2 focus:ring-[#70A681]/30 transition-all duration-300 shadow-sm" 
                    required 
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Nomor HP *</label>
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Nomor whatsapp" 
                    className="w-full p-4 rounded-xl bg-white/80 backdrop-blur-md border border-gray-300 text-gray-800 placeholder-gray-500 focus:outline-none focus:border-[#70A681] focus:ring-2 focus:ring-[#70A681]/30 transition-all duration-300 shadow-sm" 
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Layanan yang Diinginkan</label>
                  <select 
                    name="service"
                    value={formData.service}
                    onChange={handleInputChange}
                    className="w-full p-4 rounded-xl bg-white/80 backdrop-blur-md border border-gray-300 text-gray-800 focus:outline-none focus:border-[#70A681] focus:ring-2 focus:ring-[#70A681]/30 transition-all duration-300 shadow-sm">
                    <option value="">Pilih layanan yang kamu mau! (optional)</option>
                    <option value="fullbody-massage">Full Body Massage</option>
                    <option value="reflection-massage">Reflection Massage</option>
                    <option value="fullbody-reflection">Full Body Massage + Reflection</option>
                    <option value="fullbody-face">Full Body Massage + Face Massage</option>
                    <option value="fullbody-cupping-basah">Full Body Massage + Cupping Massage (Bekam Basah)</option>
                    <option value="fullbody-cupping-kering">Full Body Massage + Cupping Massage (Bekam Kering)</option>
                    <option value="fullbody-lulur">Full Body Massage + Lulur</option>
                    <option value="fullbody-hotstone">Full Body Massage + Hot Stone</option>
                    <option value="fullbody-scrapping">Full Body Massage + Scrapping (Kerok)</option>
                    <option value="fullbody-scrub">Full Body Massage + Scrub</option>
                    <option value="kids-massage">Kids Massage</option>
                    <option value="fullbody-injury">Full Body Massage + Injury Massage</option>
                    <option value="fullbody-injury-kretek">Full Body Massage + Injury Massage (Kretek)</option>
                    {/* <option value="couple-massage">Couple Massage</option> */}
                    <option value="other">Layanan lainnya</option>
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Catatan*</label>
                  <textarea 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Ceritakan kebutuhan spa-mu, permintaan khusus, atau pertanyaan lainnya..." 
                    rows={5} 
                    className="w-full p-4 rounded-xl bg-white/80 backdrop-blur-md border border-gray-300 text-gray-800 placeholder-gray-500 focus:outline-none focus:border-[#70A681] focus:ring-2 focus:ring-[#70A681]/30 resize-none transition-all duration-300 shadow-sm" 
                    required
                  ></textarea>
                </div>
                
                <button 
                  type="submit" 
                  className="w-full bg-gradient-to-r from-[#70A681] to-[#A2D1BC] text-white p-4 text-lg font-semibold rounded-xl hover:from-[#5a8a6b] hover:to-[#8bc4a7] hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 shadow-lg"
                >
                  💌 Kirim Pesan
                </button>
                
                <p className="text-sm text-gray-600 text-center">
                  Pesan akan dikirim langsung ke WhatsApp kami untuk respon yang lebih cepat!
                </p>
              </form>
            </div>
          </div>
          
          {/* Quick Booking CTA */}
          <div className="mt-16 bg-gradient-to-r from-[#F7BAD5]/30 to-[#70CAC6]/30 backdrop-blur-xl border border-white/40 rounded-3xl p-8 text-center shadow-2xl">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">🌟 Pssst… Ada diskon spesial buat member!</h3>
            <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
             Jangan ditunda lagi, tubuh & pikiran kamu deserve dimanja sekarang juga~
Langsung hubungi kami buat daftar jadi member blisspa dan dapetin berbagai keuntungannya!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
  className="bg-white/60 backdrop-blur-md border border-[#70A681] text-[#70A681] font-semibold px-8 py-3 text-lg rounded-xl hover:bg-white/80 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
  onClick={() => {
    const phoneNumber = "6282289998442"; // gunakan format internasional tanpa 0
    const message = encodeURIComponent("Assalamu'alaikum minspa, aku mau jadi member Blisspa dong...");
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  }}
>
  📱 Chat di WhatsApp
</button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8 text-center">
        <div className="max-w-6xl mx-auto px-5">
          <p className="opacity-80">© 2025 BlissSpa. All rights reserved. | Follow us on social media for updates and special offers</p>
        </div>
      </footer>
    </div>
  );
  
}

export default App;


